import React from "react";
import { IconProps } from "./IconProps";

const ArrowLeft: React.FC<IconProps> = ({
    size = 20,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 21 21"
            fill="none"
            {...props}
        >
            <path
                d="M15.8679 10.0524L4.20128 10.0749M4.20128 10.0749L10.0458 15.897M4.20128 10.0749L10.0234 4.23033"
                stroke={color}
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ArrowLeft;
